import FooterPlate from "./FooterPlate/FooterPlate";
import FooterWrapper from "./FooterWrapper/FooterWrapper";
import FooterPlaceLogos from "./FooterPlaceLogos/FooterPlaceLogos";

import popupStore from "components/Popup/PopupStore";

import qrCodeNews from "../assets/images/footer/qr-code-news.svg";
import qrCodeSupport from "../assets/images/footer/qr-code-support.svg";
import vc from "../assets/images/footer/vc.svg";

import { BANK_DETAILS, CONTACTS, SERVICES_DETAILS, VERY_USEFUL_LINKS } from "./footerConstants";
import { EVENTS, metricsEvent } from "metrics";
import { useMatchMedia } from "utils/hooks/use-match-media";

import "./Footer.scss";

export default function Footer() {
  const { isMobile } = useMatchMedia();

  return (
    <footer className="footer">
      <div className="footer__wrapper">
        <FooterPlaceLogos />
        <FooterWrapper
          className="footer__wrapper-support"
          title="Возникли сложности?"
          subtitle="За помощью сюда!"
          icon={qrCodeSupport}
          titleButton="Написать в Telegram"
          iconButton="telegram-icon-white"
          to={process.env.REACT_APP_SUPPORT_ADDRESS}
          onClick={() => { metricsEvent(EVENTS.TELEGRAM_HELP) }}
        />
        <FooterWrapper
          className="footer__wrapper-news"
          title="Обновления, новости и отзывы на сервис в канале"
          icon={qrCodeNews}
          titleButton="Канал в Telegram"
          iconButton="telegram-icon-white"
          to={process.env.REACT_APP_NEWS_ADDRESS}
          onClick={() => { metricsEvent(EVENTS.TELEGRAM_CHANNEL) }}
        />
        <FooterWrapper
          className="footer__wrapper-vc"
          title="Отзывы и обзор на сервис BOOSTCLICK"
          subtitle="О нас пишут на vc.ru"
          icon={vc}
          titleButton="Подробнее"
          to={"https://vc.ru/aggo/1027111-nakrutka-povedencheskih-faktorov-na-avito-s-boostclick"}
        />
      </div>
      <div className="footer__info">
        <div className="footer__info-left">
          <div className="footer__info-logo" />
           <div className="footer__info-note">
            *Все упомянутые бренды являются товарными знаками своих правообладателей.{" "}
            <br />
            <button onClick={() => popupStore.open("legal-info-modal")}>Подробнее…</button>
          </div>
        </div>
        <FooterPlate title="Полезные ссылки" items={VERY_USEFUL_LINKS} isMobile={isMobile} />
        <FooterPlate title="Контакты" subtitle="Верифицированные контакты сервиса" items={CONTACTS} isMobile={isMobile} />
        <FooterPlate title="Реквизиты сервиса" items={SERVICES_DETAILS} isMobile={isMobile} />
        <FooterPlate title="Банковские реквизиты" subtitle="Филиал «Северная столица» АО «РАЙФФАЙЗЕНБАНК»" items={BANK_DETAILS} isMobile={isMobile} />
      </div>
    </footer>
  );
}
